import { CSSProperties, FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ITonTransaction } from '@/api/ton/types.ts';
import TonController from '@/api/ton/ton.ts';
import TonTransaction from '@/components/EarnTon/History/TonTransaction/TonTransaction.tsx';
import ListSkeleton from '@/components/EarnTon/ListSkeleton.tsx';
import { catchErrors } from '@/utils/sentry-monitor.tsx';

const History: FC = () => {
  const [historyData, setHistoryData] = useState<ITonTransaction[] | undefined>(
    undefined
  );

  const { t } = useTranslation();

  useEffect(() => {
    const fetchTransactions = () => {
      if (!historyData) {
        setTimeout(async () => {
          try {
            const transactions = await TonController.getTransactions();
            setHistoryData(transactions.transactions);
          } catch (e) {
            catchErrors(e, true);
          }
        }, 500);
      }
    };

    fetchTransactions();
  }, []);

  return (
    <div style={containerStyle}>
      {historyData === undefined ? (
        <ListSkeleton />
      ) : historyData.length === 0 ? (
        <div style={emptyStateStyle}>{t('earn.transaction.empty_list')}</div>
      ) : (
        historyData.map((transaction) => (
          <TonTransaction
            key={transaction.id}
            tonTransactionData={transaction}
          />
        ))
      )}
    </div>
  );
};

const containerStyle: CSSProperties = {
  marginTop: '10px',
  display: 'flex',
  flexDirection: 'column',
  width: 'calc(100% - 40px)',
  marginLeft: '5px',
  marginRight: '6px',
  maxHeight: '50%',
  overflowY: 'auto',
  overscrollBehavior: 'none'
};

const emptyStateStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: 30,
  alignItems: 'center',
  height: '100%',
  color: '#666',
  fontSize: '16px'
};

export default History;
